import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=7c9310ff&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=7c9310ff&prod&scoped=true&lang=less"
import style1 from "./Feedback.vue?vue&type=style&index=1&id=7c9310ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9310ff",
  null
  
)

export default component.exports